import { useState } from 'react'
import { Spin } from 'antd'
import type { TablePaginationConfig } from 'antd'
import { useQuery } from '@apollo/client'
import {
  FREE_ANSWERS,
  FreeAnswersDataType
} from 'graphql/freeAnswer/queries'
import { ListWrapper } from './styles'
import Tables from './Tables'
import { Address } from 'globals/models/User'
import moment, { Moment } from 'moment'

interface Filter {
  field: string
  values: string[]
}

interface Props {
  currentCenters: Address[]
}

const ListFreeAnswers: React.FC<Props> = ({
  currentCenters
}) => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [currentPageSize, setCurrentPageSize] = useState<number>(10)
  const [currentFilters, setCurrentFilters] = useState<Filter[]>([])

  const { loading, data } = useQuery<FreeAnswersDataType>(
      FREE_ANSWERS, {
        variables: {
          pagination: { page: currentPage, pageLength: currentPageSize },
          filters: currentFilters
        }
      }
  )

  const setCurrentFiltersFor = (field: string, values: string[] | undefined) => (
      setCurrentFilters((currentFilters) =>
        [
          ...currentFilters.filter((el) => ( el.field != field )),
          values ? { field: field, values: values } : undefined
        ].filter((el: Filter | undefined): el is Filter => el !== undefined)
      )
  )

  const onTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, any>
  ) => {
    if (pagination.current) setCurrentPage(pagination.current)
    if (pagination.pageSize) setCurrentPageSize(pagination.pageSize)
    setCurrentFiltersFor('tracking_number', filters?.trackingNumber)
    setCurrentFiltersFor(
      'forwarded_at',
      filters?.forwardedAt?.at(0).map((el: Moment) => moment(el))
    )
    setCurrentFiltersFor(
      'created_at',
      filters?.createdAt?.at(0).map((el: Moment) => moment(el))
    )
  }

  if (loading || !data)
    return (
        <div className='absolute inset-1/2'>
          <Spin size='large' />
        </div>
    )

  const { pagination, freeAnswers } = data.freeAnswers

  return (
    <ListWrapper>
      <Tables
        currentCenters={currentCenters}
        freeAnswers={freeAnswers}
        pagination={pagination}
        onTableChange={onTableChange}
        filters={currentFilters}
      />
    </ListWrapper>
  )
}

export default ListFreeAnswers
